document.addEventListener('DOMContentLoaded', function() {



  //quantity__input  Maximum No.

document.querySelectorAll('.quantity__input').forEach(input => {
  input.addEventListener('input', () => {
    // Remove non-numbers
    let value = input.value.replace(/\D/g, '');

    // Limit to 3 digits
    if (value.length > 3) {
      value = value.slice(0, 3);
    }

    input.value = value;
  });

  input.addEventListener('blur', () => {
    let value = Number(input.value) || 0;
    const max = 999;
    const min = 1;

    if (value > max) value = max;
    if (value < min) value = min;

    input.value = value;
  });
});





  // recaptcha

  const form = document.getElementById('RegisterForm-email');

  if (form) { 
    form.addEventListener('submit', function(event) {
      const recaptchaResponse = grecaptcha.getResponse();

      if (recaptchaResponse.length === 0) {
        event.preventDefault(); 
        alert('Please verify that you are not a robot.');
        return false;
      }

      // proceed with EmailJS or AJAX
    });
  } 

 

/////////////////////////////////////////////////////////////////////



// variant-description


document.addEventListener('DOMContentLoaded', function () {
  function updateDesc() {
    const selectEl = document.querySelector('[name="id"]');
    if (!selectEl) return;

    const variantId = selectEl.value;

    document.querySelectorAll('.yagi-variant-description').forEach(el => {
      el.style.display = 'none';
    });

    const showDesc = document.querySelector(
      `.yagi-variant-description[data-variant-id="${variantId}"]`
    );
    if (showDesc) showDesc.style.display = 'block';
  }

  // Initial load
  updateDesc();

  // On variant change
  document.addEventListener('change', function (e) {
    if (e.target.matches('[name="id"]')) updateDesc();
  });
});


////////////////


//  Request a Quote button

  const openBtn = document.getElementById("rq-open-from-no-results");
  const closeBtn = document.getElementById("rq-close");
  const popup = document.getElementById("rq-popup");
  const overlay = document.getElementById("rq-popup-overlay");

  // Stop if popup or open button doesn't exist on this page
  if (!popup || !openBtn) return;

  // Open popup
  openBtn.addEventListener("click", function () {
    popup.style.display = "block";
    if (overlay) overlay.style.display = "block";
    document.body.style.overflow = "hidden";
  });

  // Close popup function
  function closePopup() {
    popup.style.display = "none";
    if (overlay) overlay.style.display = "none";
    document.body.style.overflow = "";
  }

  // Close handlers
  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);


  
});

// Request a Quote button
document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".js-quote-btn");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    document.body.style.overflow = "hidden";

    document.getElementById("rq-popup").style.display = "block";
    document.getElementById("rq-popup-overlay").style.display = "block";
  });

  document.getElementById("rq-close")?.addEventListener("click", closePopup);
  document.getElementById("rq-popup-overlay")?.addEventListener("click", closePopup);

  function closePopup() {
    document.body.style.overflow = "";
    document.getElementById("rq-popup").style.display = "none";
    document.getElementById("rq-popup-overlay").style.display = "none";
  }

});


////////////////////////////////////////////////////////////////////////////////////////////////////
